var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyOpta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.6667C4.94649 14.6021 7.58918 13.3333 10.5 13.3333C13.4108 13.3333 16.0535 14.6021 18 16.6667M14.25 6.25C14.25 8.32107 12.5711 10 10.5 10C8.42893 10 6.75 8.32107 6.75 6.25C6.75 4.17893 8.42893 2.5 10.5 2.5C12.5711 2.5 14.25 4.17893 14.25 6.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOpta);
export default __webpack_public_path__ + "static/media/my-opta.e9ba4ad349bddb0f0e77d0accd91db7c.svg";
export { ForwardRef as ReactComponent };